import { render, staticRenderFns } from "./openid-add.vue?vue&type=template&id=6c21a83c"
import script from "./openid-add.vue?vue&type=script&lang=js"
export * from "./openid-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports